var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHivis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 85 85",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "5px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m65.32 2.5c-0.28 2.43 0.62 19.19 11.5 27.86 1.44 1.15 3.3 2.31 5.68 3.23v48.91h-80v-48.91c2.75-1.02 4.81-2.36 6.32-3.61 10.67-8.86 11.97-25.36 11.67-27.48h12.51l9.68 13.37 9.31-13.37z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.5,
    x2: 42.5,
    y1: 82.5,
    y2: 16.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.27,
    x2: 82.27,
    y1: 69.94,
    y2: 69.94
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHivis);
export default __webpack_public_path__ + "static/media/hivis.a24d0bbe.svg";
export { ForwardRef as ReactComponent };